import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";

const MAX_DESCRIPTION_LENGTH = 120;

const truncateHtml = (html, maxLength) => {
  if (!html) return "";
  const text = html.replace(/<[^>]*>/g, "");
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trimEnd() + "…";
};

const CompanyProjectsTab = ({ projects }) => {
  const intl = useIntl();

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "1.25rem",
          color: "hsl(222.2, 84%, 4.9%)",
          letterSpacing: "-0.01em",
          fontFamily: "Segoe UI Bold, system-ui, sans-serif",
          display: "inline-block",
          borderBottom: "2px solid hsl(152, 60%, 32%)",
          pb: "0.25rem",
          mb: 2.5,
        }}
      >
        {intl.formatMessage({ id: "company_view.projects.count" }, { count: projects.length })}
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: "1.5rem" }}>
        {projects.map((project) => (
          <Paper
            key={project.id}
            component={Link}
            to={`project/${project.encoded_project_title}/${project.id}`}
            variant="outlined"
            sx={{
              borderRadius: "0.75rem",
              overflow: "hidden",
              textDecoration: "none",
              color: "inherit",
              transition: "box-shadow 0.2s",
              "&:hover": { boxShadow: "0 2px 8px rgba(0,0,0,0.1)" },
            }}
          >
            <Box
              component="img"
              src={project.cover_picture_url || project.small_cover_picture_url}
              alt={project.title || "Project cover"}
              loading="lazy"
              sx={{
                display: "block",
                width: "100%",
                aspectRatio: "16 / 9",
                objectFit: "cover",
                bgcolor: "hsl(210, 40%, 96.1%)",
              }}
            />
            <Box sx={{ p: 2.5 }}>
              <Typography sx={{ fontSize: "1rem", color: "hsl(222.2, 84%, 4.9%)", mb: 0.75, fontFamily: "Segoe UI Semibold, system-ui, sans-serif" }}>
                {project.title}
              </Typography>
              <Typography sx={{ color: "hsl(215.4, 16.3%, 46.9%)", fontSize: "0.875rem", lineHeight: 1.65 }}>
                {truncateHtml(project.description, MAX_DESCRIPTION_LENGTH)}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default CompanyProjectsTab;
